import React from 'react';
import { Check } from 'lucide-react';
import { CONTENT_STATUSES, getContentStatusList } from '../lib/deals';

// Multi-select checklist of content stages — tick as many as apply.
// The line preview elsewhere always shows the most-recently-ticked one.
const ContentStatusChecklist = ({ deal, isManager, onToggle }) => {
  const selected = getContentStatusList(deal);
  return (
    <div className="space-y-0.5" data-testid="content-status-checklist">
      {CONTENT_STATUSES.filter((s) => s.id !== 'not_started').map((s) => {
        const on = selected.includes(s.id);
        return (
          <button
            key={s.id}
            type="button"
            disabled={!isManager}
            onClick={() => onToggle(s.id)}
            className={`w-full flex items-center gap-2 px-2 py-1.5 rounded text-left text-sm hover:bg-slate-50 disabled:opacity-60 ${on ? 'bg-slate-50 font-medium' : ''}`}
            data-testid={`content-status-option-${s.id}`}
          >
            <span
              className="w-4 h-4 rounded border flex items-center justify-center shrink-0"
              style={on ? { background: s.color, borderColor: s.color } : { borderColor: '#cbd5e1' }}
            >
              {on && <Check className="w-3 h-3 text-white" />}
            </span>
            <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: s.color }} />
            <span style={{ color: s.color }}>{s.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ContentStatusChecklist;
